import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { TprecmApiService } from './../../../../modules/api/tprecm-api.service';
import { EcmUploadPartsComponent } from './ecm-dialogs/ecm-upload-parts/ecm-upload-parts.component';
import { ToastrService } from 'ngx-toastr';
import { EcmPartsComponent } from './ecm-dialogs/ecm-parts/ecm-parts.component';
import { ToolPartRelationshipComponent } from './ecm-dialogs/tool-part-relationship/tool-part-relationship.component';
import { EcmReportsComponent } from './ecm-dialogs/ecm-reports/ecm-reports.component';
import { DataTableComponent } from './../../../shared/data-table/data-table.component';
import { EcmNecReportsComponent } from './ecm-dialogs/ecm-nec-reports/ecm-nec-reports.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CgpAlertDialogService } from 'src/app/shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { cgpAlertTypes } from 'src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { EcmService } from './ecm.service';
import { LazyLoadEvent } from 'primeng/api/primeng-api';
import { filter, finalize } from 'rxjs/operators';
import { DataTableValidators } from './../../../shared/data-table/validators';

const FILTER_MAP = {
   toolName: 'toolNameFilter'
};

const DROP_DOWN_SORT_FIELD = {
   'engineerId': 'lastFirstName'
};

@Component({
   templateUrl: './ecm.component.html',
   styleUrls: ['../tprecm.style.scss', './ecm.component.scss']
})
export class EcmComponent implements OnInit, OnDestroy {
   private engineers: any[] = null;
   private _init: Subscription;
   private _currentFilters = {};
   data: any[];
   total = 0;
   loading = false;
   pageOptions = this.dataTableService.pageOptionsDefault();

   columns: ColumnDef[] = [
      { field: 'programNameYear', name: 'Program Name', editable: false, filterField: true, width: '13em', tooltip: 'Read Only' },
      { field: 'toolNoPrefix', name: 'Tool #(Prefix)', editable: false, filterField: true, width: '8em', tooltip: 'First 8 characters of the Tool Tip - Read Only' },
      {
         field: 'toolNoSuffix', name: '(Suffix)', filterField: true, width: '4em', tooltip: 'Last 12 characters of the Tool Number',
         validators: [
            DataTableValidators.maxLength(12),
            DataTableValidators.regex('^[a-zA-Z0-9_-]*$', 'Only A-Z, 0-9, -, and _ are allowed characters.')
         ]
      },
      { field: 'toolName', name: 'Tool Name', editable: false, filterField: true, width: '24em', tooltip: 'Read Only' },
      { field: 'tlLeadFileName', name: 'Tool File Name', validators: DataTableValidators.maxLength(15) },
      { field: 'typeName', name: 'Fixture Type', editable: false, width: '12em', tooltip: 'Read Only' },
      {
         field: 'engineerId', name: 'MSE', type: 'dropdown', sortingDisabled: false,
         optionsList: this.engineers, optionsListField: 'id', optionsListName: 'lastFirstName', width: '11em', placeHolderField: 'lastFirstName'
      },
      { field: 'userSource', name: 'User Source', editable: false, width: '12em', tooltip: 'Read Only' },
      { field: 'tprCreateDate', name: 'Date Created', type: 'date', editable: false, width: '6em' },
   ];
   hasLoaded = false;
   resourced = false;
   selectedEcmTool$: BehaviorSubject<any> = new BehaviorSubject(null);

   @ViewChild('tools', { static: false }) dataTable: DataTableComponent;

   constructor(
      private readonly router: Router,
      private readonly cgpAlertDialogService: CgpAlertDialogService,
      private readonly ecmService: EcmService,
      private readonly dialog: MatDialog,
      private readonly toastr: ToastrService,
      private readonly dataTableService: DataTableService
   ) { }

   ngOnInit() {
      if (!this.selectionCriteria) {
         this._init = this.cgpAlertDialogService.showAlertDialog({
            title: 'Invalid Selection Criteria',
            message: 'A selection criteria has not been selected. Redirecting back to the main page.',
            alert: cgpAlertTypes.warning,
            closeLabel: 'OK'
         }).afterClosed().subscribe(
            () => this.router.navigate([''])
         );
      }

      if (this.router.url === '/tprecm/ecm/re-source') {
         this.resourced = true;
         this.columns.forEach(val => {
            val.editable = false;
            val.headerHighlight = false;
         });
      }

      if (this.resourced) {
         this.columns.forEach(val => {
            if (val.field === 'programNameYear' || val.field === 'toolNoPrefix' || val.field === 'toolNoSuffix' || val.field === 'toolName'
               || val.field === 'tlLeadFileName' || val.field === 'typeName' || val.field === 'userSource') {
               return (val.type = 'readonly');
            }
         });
      }

      this.updateNameSources();
      this.hasLoaded = true;
   }

   ngOnDestroy() {
      if (this._init) {
         this._init.unsubscribe();
      }
   }

   loadECMs(selectedTool?: any) {
      this.loading = true;

      const body = {
         ...this.selectionCriteria,
         filterColumn: this._currentFilters,
         reSourced: +this.resourced,
      };

      this.ecmService.getAllTools(body, this.pageOptions)
         .pipe(
            filter(Boolean),
            finalize(() => this.loading = false)
         ).subscribe((res: { totalCount: number, data: any[] }) => {
            this.total = res.totalCount;
            this.data = res.data;
            if (selectedTool) {
               this.dataTable.selections = [this.data.find(tool => tool.toolId === selectedTool.toolId)];
               this.selectedEcmTool$.next(this.dataTable.selections[0]);
            }
            else if (this.data.length >= 1) {
               this.dataTable.selections = [this.data[0]];
               this.selectedEcmTool$.next(this.data[0]);
            }

         });
   }


   onSelect(selectedEcmTool) {
      if (selectedEcmTool && this.selectedEcmTool$.value && selectedEcmTool.toolId === this.selectedEcmTool$.value.toolId) {
         return;
      }

      this.selectedEcmTool$.next(selectedEcmTool);
   }

   updateNameSources() {
      this.ecmService.getEngineerCriteria()
         .subscribe((val) => {
            this.engineers = val;
            this.columns
               .find((column: ColumnDef) => column.field === 'engineerId')
               .optionsList = this.engineers;
         }
         );
   }

   private isPageDifferent(page: PageOptions, event: LazyLoadEvent) {
      const sortField: string = DROP_DOWN_SORT_FIELD[event.sortField] || event.sortField;
      
      return [
         page.order !== (event.sortOrder === 1 ? 'asc' : 'desc'),
         page.size !== event.rows,
         page.sort !== sortField,
         page.page !== event.first / this.pageOptions.size,
         Object.keys(this._currentFilters).length !== Object.keys(event.filters).length,
         Object.entries(this._currentFilters).some(([key, value]) => !event.filters[key] || event.filters[key].value !== value)
      ].some(v => v);
   }

   onLazyLoad(event: LazyLoadEvent) {
      if (!this.isPageDifferent(this.pageOptions, event)) {
         return;
      }

      const sortField: string = DROP_DOWN_SORT_FIELD[event.sortField] || event.sortField;
      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;

      this._currentFilters = Object.entries(event.filters)
         .reduce((obj, [key, value]) => ({ ...obj, [FILTER_MAP[key] || key]: value.value }), {});

      this.loadECMs();
   }

   onBackButtonClicked = () => {
      this.router.navigate(['']);
   }

   private getParam(obj: any, id: string): any | undefined {
      return obj ? obj[id] : undefined;
   }

   get selectionCriteria(): { [field: string]: any } {
      const selections = JSON.parse(sessionStorage.getItem('selections')) || { areas: [] };
      const programIds = selections.programs.map((p: any) => p.id);

      return {
         programIds: programIds.length > 0 ? programIds : undefined,
         chkBiw: selections.areas.includes('BIW'),
         chkDei: selections.areas.includes('DEI'),
         chkGae: selections.areas.includes('GAE'),
         engineerId: this.getParam(selections.engineer, 'id'),
         partNumber: this.getParam(selections.partNoLH, 'partNumber'),
         stablePartCode1: this.getParam(selections.cspcLH, 'stablePartCode1'),
         toolNo: this.getParam(selections.gageNo, 'toolNo'),
         cfe: this.getParam(selections.constEngineer, 'cfe'),
         dsRep: this.getParam(selections.designSourceRep, 'dsRep'),
         partNumber2: this.getParam(selections.partNoRH, 'partNumber2'),
         stablePartCode2: this.getParam(selections.cspcRH, 'stablePartCode2'),
         typeId: this.getParam(selections.fixtureType, 'id'),
         firstUserSourceId: this.getParam(selections.firstUserSource, 'id'),
         designSourceId: this.getParam(selections.designSource, 'id'),
         userSourceId: this.getParam(selections.userSource, 'id'),
         constSourceId: this.getParam(selections.buildSource, 'id'),
         toolName: selections.keyword || undefined,
         reSourced: 0
      };
   }

   /** ECM BUTTONS */
   onEcmNecReportsClick(tool: EcmComponent) {
      // If no rows are selected do nothing
      if (!this.selectedEcmTool$.value || Object.keys(this.selectedEcmTool$.value).length === 0) {
         this.toastr.error('Please select a tool to view NEC Reports for');
         return;
      }
      const dialogRef = this.dialog.open(EcmNecReportsComponent, {
         disableClose: true,
         height: '54vh',
         width: '54vw',
         data: {
            tool: this.selectedEcmTool$.value,
            readonly: this.resourced
         }
      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.loadECMs());
   }

   onEcmReportsClick() {
      const dialogRef = this.dialog.open(EcmReportsComponent, {
         disableClose: true,
         data: this.selectedEcmTool$.value,

      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.loadECMs());
   }

   onToolPartRelationshipClick() {
      // If no rows are selected do nothing
      if (!this.selectedEcmTool$.value || Object.keys(this.selectedEcmTool$.value).length === 0) {
         this.toastr.error('Please select a tool to view part relationships for.');
         return;
      }

      const dialogRef = this.dialog.open(ToolPartRelationshipComponent, {
         disableClose: true,
         height: '74vh',
         width: '74vw',
         data: {
            tool: this.selectedEcmTool$.value,
            readonly: this.resourced
         },

      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe((data: any) => this.loadECMs(data));
   }

   onEcmPartsClick() {
      // If no rows are selected do nothing
      if (!this.selectedEcmTool$.value || Object.keys(this.selectedEcmTool$.value).length === 0) {
         this.toastr.error('Please select a tool to view parts for.');
         return;
      }

      const dialogRef = this.dialog.open(EcmPartsComponent, {
         disableClose: true,
         height: '90vh',
         width: '90vw',

         data: {
            tool: this.selectedEcmTool$.value,
            readonly: this.resourced
         }
      });

      dialogRef.afterClosed()
         .subscribe((data: any) => this.loadECMs(data));
   }

   onEcmPartsUploadClick() {
      if (!this.selectedEcmTool$.value || Object.keys(this.selectedEcmTool$.value).length === 0) {
         this.toastr.error('Please select a tool to upload parts for.');
         return;
      }

      const dialogRef = this.dialog.open(EcmUploadPartsComponent, {
         disableClose: true,

         panelClass: 'tprecm-modal-panel',
         data: this.selectedEcmTool$.value
      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.loadECMs());
   }

   updateTool(event: any) {
      const body = event.data;
      body.toolNoSuffix = body.toolNoSuffix ? body.toolNoSuffix.toUpperCase() : body.toolNoSuffix;
      body.tlLeadFileName = body.tlLeadFileName ? body.tlLeadFileName.toUpperCase() : body.tlLeadFileName;
      this.ecmService.updateEcmTool(body).subscribe();
   }
}
